import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import InputField from "components/form/InputField";
import SelectField from "components/form/SelectField";
import FormActionButtons from "components/Button/FormActionButtons";
import AlertDialog from "../../../../components/Feedback/AlertDialog";
import { createTransportation } from "../../../../services/transportationsServices";
import { getAllSuppliers } from "../../../../services/supplierService";
import { getAllSubAgents } from "../../../../services/subAgentService";
import { getAllPartners } from "../../../../services/userServices/partnerService";

const AddAngkutan = () => {
  const navigate = useNavigate();
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [subAgentOptions, setSubAgentOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const suppliers = await getAllSuppliers();
        setSupplierOptions(
          suppliers.map((s) => ({ value: s.id, label: s.name }))
        );

        const subAgents = await getAllSubAgents();
        setSubAgentOptions(
          subAgents.map((sa) => ({ value: sa.id, label: sa.name }))
        );

        const partners = await getAllPartners();
        setUserOptions(
          partners.map((p) => ({
            value: p.id,
            label: p.profiles?.full_name || "No Name",
          }))
        );
      } catch (err) {
        console.error("Gagal memuat data dropdown:", err);
      }
    };

    fetchDropdowns();
  }, []);

  const onSubmit = async (data) => {
    try {
      const payload = {
        vehicleNumber: data.vehicleNumber,
        supplierId: data.supplier?.value || data.supplier,
        subAgentId: data.subAgent?.value || data.subAgent,
        userId: data.user?.value || data.user,
      };

      await createTransportation(payload);

      setIsAlertOpen(true);
    } catch (err) {
      if (err.response) {
        alert(
          "Error: " +
            (err.response.data.message || JSON.stringify(err.response.data))
        );
      } else {
        alert("Terjadi kesalahan saat menyimpan data.");
      }
    }
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-3xl p-6 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-6 text-xl font-semibold text-center text-green-700 sm:text-xl">
          Tambah Data Angkutan
        </h2>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Kolom Kiri */}
          <div className="space-y-4">
            <InputField
              label="Nomor Kendaraan"
              name="vehicleNumber"
              {...register("vehicleNumber", {
                required: "Nomor Kendaraan wajib diisi",
              })}
              error={errors.vehicleNumber}
            />

            <SelectField
              label="Supplier"
              name="supplier"
              control={control}
              options={supplierOptions}
              rules={{ required: "Supplier wajib dipilih" }}
              error={errors.supplier}
            />
          </div>

          {/* Kolom Kanan */}
          <div className="space-y-4">
            <SelectField
              label="Sub Agent"
              name="subAgent"
              control={control}
              options={subAgentOptions}
              rules={{ required: "Sub Agent wajib dipilih" }}
              error={errors.subAgent}
            />

            <SelectField
              label="Full Name"
              name="user"
              control={control}
              options={userOptions}
              rules={{ required: "User wajib dipilih" }}
              error={errors.user}
            />
          </div>
        </div>

        <FormActionButtons
          submitLabel="Simpan"
          cancelLabel="Batal"
          onCancel={() => navigate("/verifikasi/data-angkutan")}
          className="mt-8"
        />
      </form>
      {isAlertOpen && (
        <AlertDialog
          isOpen={isAlertOpen}
          onClose={() => {
            setIsAlertOpen(false);
            navigate("/verifikasi/data-angkutan");
          }}
          title="Berhasil"
          message="Data angkutan berhasil ditambahkan!"
        />
      )}
    </div>
  );
};

export default AddAngkutan;
